exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".automation-result-overview .row[data-v-eb3f1eda] {\n  border-radius: 5px;\n  padding: 5px;\n}\n.automation-result-overview .ant-select[data-v-eb3f1eda] {\n  width: 100% !important;\n  display: block !important;\n}", ""]);

// exports
